import { Answers } from './answers';

export class Questions {
  UniqueNumber: number;
  AnswerID: number;
  selectAnsValue: number = 0;
  AnswerText: string;
  page_no: number;
  qno: number;
  //seq: number;
  uniqueqno: number;
  qtitle: string;
  pipingQuationTitle: string;
  //PipeQTitle: string;
  QuestionTip: string;
  qsubtype: number;
  qtype: string;
  constraintType: number;
  constraintNum: number;

  other: boolean;
  other_text: string;
  otherAnswer: string;
  isOtherAnswer: boolean;
  twidth: number;
  tHeight: number;
  mandatory: boolean;
  isSoftRequired: boolean;
  isSoftRequiredHandle: boolean = false;
  SoftReqErrorMsg: string;
  qid: number;
  error_msg: string;
  hasImages: boolean;
  hasMedia: boolean;
  DispAnsCol: number;
  DispAnsFormat: number;
  totalAnswers: number;
  Answers: Answers[];

  AnsPipeQID: number;
  AnsPipeCondition: number;
  AnsPipeRankLimit: number;
  //public float CorrectScore
  hasCorrectAns: boolean;
  isDrillSearchEnable: boolean;
  // : number inCorrectScore
  isShowReportingVal: boolean;
  RS_Type: number;
  RSFormat: number;
  isOverAllStyleApplied: boolean;
  MTBTitleLocation: number;
  isreenter: number;
  reEnterErrMsg: string;
  ImageSize: number;
  isQuotaMgmtON: boolean;
  Rule_id: number;
  DemographicFieldID: number;
  SpssCode: string;
  isUniformWidth: boolean;
  isadvbranching: boolean;
  uniquecno: number;
  apply_currency: number;
  M_Text: number;
  isAnchorReverse: boolean;
  // : number question_sequence
  append_percentage: number;
  custom_format: string;
  currency_name: string;
  M_Pos: number;
  other_pageto: number;

  MediaText: string;
  rank_limit: number;
  dna_pageto: number;
  date_default: string;
  piping: boolean;
  answer_style: number;
  branch: boolean;
  sub_qno: number;
  group_no: number;
  tsize: string;
  ms_date: Date;

  // QuestionImages_1: QuestionImage[];
  // QuestionImages_2: QuestionImage[];
  // QuestionMedias_1: QuestionMedia[];
  // QuestionMedias_2: QuestionMedia[];

  QuestionImageAndMedia_1: QuestionImageAndMedia[];
  QuestionImageAndMedia_2: QuestionImageAndMedia[];

  isSQ: boolean;
  isADLSQ: boolean;
  isCQ: boolean;
  isCQHide: boolean;
  rules: Rules[];
  QDLCondStatuses: QDLCondStatus[];
  ADLRules: adlRules[];

  pageto: number;

  population_type: number;
  characterLimit: number;
  Showcharlimit: boolean;
  RemainingChr: string;

  currency_Symbol: string;

  num_range_1: string;
  num_range_2: string;

  RotateIndex: number;
  ansConstraint: string;
  //ansConstraint: number;
  dataSecretKey: string;
  subQnoinChar: string;
  uniform_width: boolean;
  IsShowClearOption: boolean;
  ClearOptionErrorMsg: string;
  AllowOnlyInteger: boolean;

  /*Client Side Property */
  InlineQDL: boolean;
  isValid: boolean;
  isReEnterEmail: boolean;
  isReEnterEmailValid: boolean;
  selectedOptionList: SelectedOptionList[];
  isAlertDanger: boolean;
  isMultiQuestion: boolean;
  isMatrixQuestion: boolean;
  isGroupRule: boolean = false;
  isNOGroupRule: boolean = false;
  isGroupCQHide: boolean = false;
  isMandatoryStar: boolean;
  isMultiControlValid: boolean;
  ReEnterBlankMessage: string;
  isNA: boolean;
  isLoading: boolean;
  IsDisabled: boolean;
  PrePopValue: number;
  PrePopText: string;
  isMandatoryInvalid: boolean;
  isGoBackQuota: boolean;
  Custom_Message: string;
  DestinationQuestions: DestinationQuestion[];
  SelectedCountry: string;
  isFirstShowQuestion: boolean;
  isMultiQuestionPiping: boolean;
  IsOfflineSkipQuestion: boolean;
  IsShowEmoji: boolean;
  PaletteID: number;
  IsADLRuleApplied: boolean;
  isAllADLHide: boolean;
  isInlineShown: boolean;
  isHiddenQ: boolean;
  grpRotateIndex: number;
  reEnterEmailLabel: string;
  isPreviewPropChange: boolean = false;
  isDirectoryLinkedQ: boolean;
  isDirectoryHidden: boolean;
}

export class adlRules {
  ADLValueId: number;
  ADLValueText: string;
  ADLConditions: adlConditions[];
  Rule_id: number;
}
export class adlConditions {
  SourceValueId: number;
  ConditionQID: number;
  ConditionQPageNo: number;
  ConditionValue: string;
  Operator: string;
}

export class Rules {
  SourceValueId: number;
  ConditionQID: number;
  ConditionValue: string;
  Operator: string;
  ConditionQPageNo: number;
  InlineQDL: boolean;
  Rule_id: number;
  DestinationQID: number;
  cond_match_type: number;
  rule_expression: string;
  condition_name: string;
}

export class QDLCondStatus {
  SourceQID: number;
  CondName: string;
  Status: boolean;
  rule_expression: string;
}

export class ContactRules {
  Condition_Type: number;
  DirectoryId: number;
  isDirectoryLinking: boolean;
  ActivityId: number;
  DirectoryActivityColumnId: number;
  ActivityCriteriaColumnId: number;
  ActivityCriteriaId: number;
  ConditionQID: number;
  ConditionQPageNo: number;
  ConditionValue: string;
  ContactValue: string;
  DataType: string;
  Operator: string;
  InlineQDL: boolean;
  DestinationQID: number;
  Rule_id: number;
  cond_match_type: number;
  rule_expression: string;
  condition_name: string;
  isLinked: boolean;
}

export class DestinationQuestion {
  rule_id: number;
  ConditionQID: number;
}

export enum PopulationType {
  PreEditable = 1,
  PreHide = 2,
  PreRead = 3,
}

export class SelectedOptionList {
  value_id: number;
  value_text: string;
  isOther: boolean;
}

export class PrePopDetails {
  UniqueNumber: number;
  preText: string;
  preValue: number;
  isHide: boolean;
}

export class QuestionImageAndMedia {
  IsImage: boolean;
  ImageAndMedia_id: number;
  Zarca_q_id: number;
  Name: string;
  URL: string;
  Position: number;
  Caption: string;
  Order: number;
  Size: number;
  HPosition: number;
  RowPosition: number;
  ColPosition: number;
  IsLoadFile: boolean;
  VideoEmbedPath: string;
  ImagePath: string;
  FillFitPostion: number;
}

export class CountryData {
  Country: string;
  CountryCode: any;
  SecondaryLanguage: string;
  PlaceholderNumber: string;
  TextLength: number;
}

export enum AnswerPipingType {
  AllAnswer = 1,
  SelectedAnswer = 2,
  UnselectedAnswer = 3,
  DisplayedAnswer = 4,
  NotDiplayedAnswer = 5,
  RankLowerThan = 6,
  RankHigherThan = 7,
  RankOptionEqual = 8,
  RankOptionHighest = 9,
  RankOptionLowest = 10,
}

export class AcceptCookiesCountryData {
  Country: string;
  CountryCode: any;
}

export class FontDataForSignature {
  Font_id: number;
  Font_Name: string;
  DefaultFont_Size: number;
  CharBetween23_30: number;
  CharBetween31_40: number;
  CharBetween41_100: number;
}
